import { TrendingUpIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PagePlaceHolder } from './PagePlaceHolder';

export function LifespanPage() {
	const { t } = useTranslation();
	return (
		<PagePlaceHolder
			title={t('assets.pages.lifespan.title')}
			description={t('assets.pages.lifespan.description')}
			Icon={TrendingUpIcon}
		/>
	);
}
